import React, { useState, useEffect } from "react";

const ComingSoon = () => {
  const [videoSrc, setVideoSrc] = useState("/vid1.mp4");

  useEffect(() => {
    function updateVideoSrc() {
      if (window.innerWidth <= 640) {
        setVideoSrc("/vid2.mp4");
      } else {
        setVideoSrc("/vid1.mp4");
      }
    }

    updateVideoSrc();

    window.addEventListener("resize", updateVideoSrc);
    return () => window.removeEventListener("resize", updateVideoSrc);
  }, []);

  return (
    <div className="relative w-full h-screen bg-black overflow-hidden">
      {/* Video container with height calc(100vh - 5vh) */}
      <div style={{ height: "calc(100vh - 5vh)" }}>
        <video
          src={videoSrc}
          autoPlay
          muted
          loop
          playsInline
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
          }}
        />
      </div>

      {/* Logo overlay */}
      <div className="absolute top-0 left-0 z-10 pl-8 pt-0">
        <img
          src="/logo w-01.png"
          alt="Logo"
          className="w-20 h-20 object-contain sm:w-48 sm:h-auto"
          style={{ display: "block" }}
        />
      </div>

      {/* Footer fixed at bottom */}
      <footer
        className="fixed bottom-0 left-0 w-full z-10 flex items-center justify-end px-6"
        style={{ height: "5vh", backgroundColor: "#484849" }}
      >
        <div className="flex space-x-6 text-white">
          {/* Social icons */}
          <a
            href="https://www.facebook.com/people/TheCraftry/61576866561267/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
            className="hover:text-blue-600"
          >
            {/* Facebook SVG */}
            <svg
              className="w-6 h-6 fill-current"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
            >
              <path d="M22.675 0h-21.35C.6 0 0 .6 0 1.325v21.351C0 23.4.6 24 1.325 24H12.82v-9.294H9.692v-3.622h3.127V8.413c0-3.1 1.893-4.788 4.658-4.788 1.325 0 2.464.098 2.796.142v3.24l-1.918.001c-1.504 0-1.796.715-1.796 1.763v2.31h3.59l-.467 3.622h-3.123V24h6.116c.725 0 1.325-.6 1.325-1.324V1.325C24 .6 23.4 0 22.675 0z" />
            </svg>
          </a>

          <a
            href="https://www.instagram.com/thecraftry.agency/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            className="hover:text-pink-500"
          >
            {/* Instagram SVG */}
            <svg
              className="w-6 h-6 fill-current"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
            >
              <path d="M7.75 2h8.5A5.75 5.75 0 0122 7.75v8.5A5.75 5.75 0 0116.25 22h-8.5A5.75 5.75 0 012 16.25v-8.5A5.75 5.75 0 017.75 2zm0 1.5A4.25 4.25 0 003.5 7.75v8.5A4.25 4.25 0 007.75 20.5h8.5a4.25 4.25 0 004.25-4.25v-8.5a4.25 4.25 0 00-4.25-4.25h-8.5zM12 7a5 5 0 110 10 5 5 0 010-10zm0 1.5a3.5 3.5 0 100 7 3.5 3.5 0 000-7zm4.75-.75a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0z" />
            </svg>
          </a>

          <a
            href="https://www.linkedin.com/company/thecraftry"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
            className="hover:text-blue-700"
          >
            <svg
              className="w-6 h-6 fill-current"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
            >
              <path d="M4.98 3.5C4.98 5.43 3.4 7 1.5 7S-2 5.43-2 3.5 0.6 0 2.5 0 4.98 1.57 4.98 3.5zM.08 8.5H5v15H.08v-15zM7.5 8.5h4.79v2.16h.07c.67-1.27 2.3-2.6 4.72-2.6 5.05 0 5.98 3.32 5.98 7.64v8.8h-5v-7.8c0-1.86-.03-4.25-2.59-4.25-2.6 0-3 2.03-3 4.13v7.92h-5v-15z" />
            </svg>
          </a>
        </div>
      </footer>
    </div>
  );
};

export default ComingSoon;
